import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'atsFilterByProp',
    standalone: false
})
export class AtsFilterByPropPipe implements PipeTransform {
	transform(arr: any[], prop: string, value: any): any {
		return arr.filter(val => val[prop] === value);
	}
}
